import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateCenteredTextBlock(section, block, textLines, hr, line, buttons) {

  // Inidividual tweens
  // Block
  let blockTween = block ? gsap.to(block, {
    duration: 0.5,
    opacity: 1,
  }) : null;

  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated hr 
  let hrTween = hr ? gsap.to(hr, {
    width: "100%",
    duration: 0.4,
    opacity: 1
  }) : null;

  // Animated diagonal red line
  let lineTween = line ? gsap.to(line, {
    width: "100%",
    duration: 5,
    ease: "power2.out",
  }) : null;

  // Buttons div
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl
    .add(blockTween)
    .addLabel("blockIn")
    .add(textLinesTween, "blockIn")
    .add(hrTween, "blockIn+=0.2")
    .add(buttonsTween, "-=0.5")
    .add(lineTween, "-=0.75");
}